import React from 'react'
import styles from './styles.module.css'

const Index = () => {
  return (
    <div className={styles.wrapper}>НЕТ ДАННЫХ</div>
  )
}

export default Index
